import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer text-center" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 mb-5 mb-lg-0" }, null, -1)
const _hoisted_5 = { class: "col-lg-6 mb-5 mb-lg-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "text-uppercase mb-4" }, "Presence na internetu", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PresenceIcon = _resolveComponent("PresenceIcon")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_PresenceIcon, {
            serviceClass: "fa-facebook-f",
            url: "https://www.facebook.com/jan.pilar.37/"
          }),
          _createVNode(_component_PresenceIcon, {
            serviceClass: "fa-twitter",
            url: "https://twitter.com/pilarik31"
          }),
          _createVNode(_component_PresenceIcon, {
            serviceClass: "fa-reddit-alien",
            url: "https://www.reddit.com/user/pilarik31/"
          }),
          _createVNode(_component_PresenceIcon, {
            serviceClass: "fa-linkedin-in",
            url: "https://www.linkedin.com/in/jan-pila%C5%99-09a750172/"
          }),
          _createVNode(_component_PresenceIcon, {
            serviceClass: "fa-github",
            url: "https://github.com/pilarik31"
          }),
          _createVNode(_component_PresenceIcon, {
            serviceClass: "fa-stack-overflow",
            url: "https://stackoverflow.com/users/8942154/pilarik31"
          }),
          _createVNode(_component_PresenceIcon, {
            serviceClass: "fa-steam",
            url: "https://steamcommunity.com/id/pilarik31/"
          }),
          _createVNode(_component_PresenceIcon, {
            serviceClass: "fa-spotify",
            url: "https://open.spotify.com/user/pilarik31"
          })
        ]),
        _hoisted_7
      ])
    ])
  ]))
}